// @flow

//
// React
//
import React, { useContext, useEffect, useLayoutEffect } from "react";

//
// React Router
//
import { Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';

//
// Material UI
//
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useTheme, useMediaQuery } from '@mui/material';

//
// Hal Forms
//
import HalFormsContext from '../../../../../lib/trix-web-hal-forms/context/HalFormsContext';
import HalFormsComponent from '../../../../../lib/trix-web-hal-forms/component/HalFormsComponent';

import RetailSaleConfigurationComboBox from '../form/RetailSaleConfigurationComboBox';

//
// Props
//
type Props = {
    //
    // Hal forms template
    //
    __halFormsTemplate: any,

    //
    // Ducks
    //
    __ducks: {
        actions: any,
        selectors: any,
    },

    //
    // Refs
    //
    __dataSourcesRef: any,

    //
    // Components registry
    //
    __componentsRegistry: any,

    //
    // Data Source Extender props (in case data source set)
    //
    __dataSourceExtender: {
        dataSource: any,
        loadData: (params: any) => void,
        isDataLoadNeeded: (params: any) => boolean,
        isLoadingData: boolean,
        params: any,
        data: any,
    },

    //
    // Container
    //
    container: any,

    //
    // Data
    //
    data: any,

    //
    // Handlers
    //
    onChange: (value: any, meta: any) => void,
    onClose: () => void,
    onDataLoad: (data: any) => void,
} // End of Props


//
// Component
//
const RootContainer = (props: Props): any => {
    let selectRetailSaleConfigurationHalFormTemplate: any = props.__halFormsTemplate;
    let manageRetailSaleContainer: any = props.__halFormsTemplate;
    for (let i in props.__halFormsTemplate.components) {
        if (props.__halFormsTemplate.components[i].name === 'selectRetailSaleConfigurationForm') {
            selectRetailSaleConfigurationHalFormTemplate = props.__halFormsTemplate.components[i];
        }
        if (props.__halFormsTemplate.components[i].name === 'manageRetailSaleContainer') {
            manageRetailSaleContainer = props.__halFormsTemplate.components[i];
        }
    }

    // if configuration selected - show manage retail sale, otherwised - show select configuration container
    if (props.data && props.data.retailSaleConfiguration && props.data.retailSaleConfiguration.id) {
        return(
            <HalFormsComponent
                __componentsRegistry={props.__componentsRegistry}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                __halFormsTemplate={props.__halFormsTemplate}
                onChange={props.onChange}
                onClose={props.onClose}
                c={manageRetailSaleContainer}
                container={props.data.retailSaleConfiguration}
                data={props.data}
            />
        );
    } else {
        return(
            <HalFormsComponent
                __componentsRegistry={props.__componentsRegistry}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                __halFormsTemplate={props.__halFormsTemplate}
                onChange={props.onChange}
                onClose={props.onClose}
                c={selectRetailSaleConfigurationHalFormTemplate}
                container={props.container}
                data={props.data}
            />
        );
    }
}

export default RootContainer;